var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("settings.setting_label"),
        icon: "icon-gearwheels",
        colWidth: "6",
      },
    },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _vm.currentTab === "6"
              ? _c("dp-settings", { attrs: { settings: _vm.DPSettingsData } })
              : _vm.currentTab === "1"
              ? _c("rtp-settings", { attrs: { settings: _vm.RTPSettingsData } })
              : _vm.currentTab === "2"
              ? _c("ml-settings", { attrs: { settings: _vm.MLSettingsData } })
              : _vm.currentTab === "3"
              ? _c("ds-settings", { attrs: { settings: _vm.DSSettingsData } })
              : _vm.currentTab === "8"
              ? _c("mp-settings", { attrs: { settings: _vm.MPSettingsData } })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footerButtons" },
        [
          _vm.canEditSettings()
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "form-group",
                      attrs: { cols: "12", md: "6", "offset-md": "3" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "lg" },
                          on: { click: _vm.changeApplicationSettings },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }